import React, { useState, useEffect } from "react";

const LicenciaSelect = ({ onChange, licenciaInicial }) => {
  const tiposLicencia = [
    {
      codigo: "A",
      descripcion: "Motocicletas",
      subclases: [
        { codigo: "A1", descripcion: "Ciclomotores hasta 50cc" },
        { codigo: "A2", descripcion: "Motos hasta 150cc" },
        { codigo: "A3", descripcion: "Motos de más de 150cc" },
      ],
    },
    {
      codigo: "B",
      descripcion: "Automóviles particulares",
      subclases: [
        { codigo: "B1", descripcion: "Autos y camionetas hasta 3.500 kg" },
        { codigo: "B2", descripcion: "Autos con remolque hasta 750 kg" },
      ],
    },
    {
      codigo: "C",
      descripcion: "Camiones sin acoplado",
      subclases: [{ codigo: "C1", descripcion: "Camiones sin acoplado" }],
    },
    {
      codigo: "D",
      descripcion: "Transporte de pasajeros",
      subclases: [
        { codigo: "D1", descripcion: "Transporte de hasta 8 pasajeros" },
        { codigo: "D2", descripcion: "Transporte de más de 8 pasajeros" },
        { codigo: "D3", descripcion: "Transporte de emergencia y escolar" },
      ],
    },
    {
      codigo: "E",
      descripcion: "Camiones articulados y maquinaria especial",
      subclases: [
        { codigo: "E1", descripcion: "Camiones con acoplado" },
        { codigo: "E2", descripcion: "Maquinaria especial no agrícola" },
      ],
    },
    {
      codigo: "F",
      descripcion: "Vehículos para personas con discapacidad",
      subclases: [{ codigo: "F1", descripcion: "Vehículos adaptados" }],
    },
    {
      codigo: "G",
      descripcion: "Vehículos agrícolas",
      subclases: [
        { codigo: "G1", descripcion: "Tractores agrícolas" },
        { codigo: "G2", descripcion: "Máquinas agrícolas autopropulsadas" },
      ],
    },
  ];

  const [poseeLicencia, setPoseeLicencia] = useState("");
  const [seleccionadas, setSeleccionadas] = useState([]);

  useEffect(() => {
    
    if (licenciaInicial!="NO"&&licenciaInicial!="") {
      // Mapear licenciaExistente a la estructura seleccionadas
      const licenciaMapeada = licenciaInicial.split(", ").map((item) => {
        const [tipo, subclase] = item.split("-");
        return { tipo, subclase };
      });
     
      setPoseeLicencia("SI");
      setSeleccionadas(licenciaMapeada);
    }else if(licenciaInicial==="NO"){      setPoseeLicencia("NO");}
  }, [licenciaInicial]);

  const handlePoseeLicenciaChange = (event) => {
    const value = event.target.value;
    setPoseeLicencia(value);
    setSeleccionadas([]);
    onChange(value === "NO" ? "NO" : "");
  };

  const handleTipoChange = (event) => {
    const tipo = event.target.value;
    if (!seleccionadas.some((item) => item.tipo === tipo)) {
      setSeleccionadas([...seleccionadas, { tipo, subclase: "" }]);
    }
  };

  const handleSubclaseChange = (tipo, subclase) => {
    const nuevasSeleccionadas = seleccionadas.map((item) =>
      item.tipo === tipo ? { ...item, subclase } : item
    );
    setSeleccionadas(nuevasSeleccionadas);
    onChange(nuevasSeleccionadas.map((item) => `${item.tipo}-${item.subclase}`).join(", "));
  };

  const handleEliminarTipo = (tipo) => {
    const nuevasSeleccionadas = seleccionadas.filter((item) => item.tipo !== tipo);
    setSeleccionadas(nuevasSeleccionadas);
    onChange(nuevasSeleccionadas.length > 0
      ? nuevasSeleccionadas.map((item) => `${item.tipo}-${item.subclase}`).join(", ")
      : ""
    );
  };

  // Mapea los tipos de licencia y sus subclases a las opciones de los selects
  const getTipoOptions = () => {
    return tiposLicencia.map((tipo) => (
      <option key={tipo.codigo} value={tipo.codigo}>
        {tipo.codigo} - {tipo.descripcion}
      </option>
    ));
  };

  const getSubclaseOptions = (tipo) => {
    const tipoSeleccionado = tiposLicencia.find((t) => t.codigo === tipo);
    return tipoSeleccionado?.subclases.map((subclase) => (
      <option key={subclase.codigo} value={subclase.codigo}>
        {subclase.codigo} - {subclase.descripcion}
      </option>
    )) || [];
  };

  return (<>

 
    <div >
      <div  className={`form-control ${!poseeLicencia ? "is-invalid" : "is-valid" }`}>
     
      <select
      id="poseeLicencia"
          value={poseeLicencia}
          onChange={handlePoseeLicenciaChange}
          required
          

      
      >  <option value="">-- Seleccionar --</option>
      <option value="NO">No Posee</option>
      <option value="SI">Sí Posee</option></select>
      </div>
      {poseeLicencia === "SI" && (
        <><div className={`form-control ${!seleccionadas ? "is-invalid" :seleccionadas.clase?"is-valid":""}`} style={{border:"1px solid #aaa", padding:"10px",backgroundColor:"#eee"}}> 
          <label htmlFor="tipoLicencia">Seleccionar tipo de licencia para Agregar:</label>
          <select id="tipoLicencia" onChange={handleTipoChange}>
            <option value="">-- Seleccionar --</option>
            {getTipoOptions()}
          </select>
          </div>
          {seleccionadas.map(({ tipo, subclase }) => (
            <div key={tipo}  className={`form-control ${!seleccionadas ? "is-invalid" :subclase? "is-valid":"is-invalid"}`}>
              <label htmlFor={`subclase-${tipo}`}>Subclase para {tipo}:</label>
              <select
                id={`subclase-${tipo}`}
                value={subclase}
                onChange={(e) => handleSubclaseChange(tipo, e.target.value)}
              >
                <option value="">-- Seleccionar --</option>
                {getSubclaseOptions(tipo)}
              </select>
              <button className="btn btn-danger" onClick={() => handleEliminarTipo(tipo)}>❌ Eliminar</button>
            </div>
          ))}
    </>
      )}
    </div></>
  );
};

export default LicenciaSelect;
